import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import './GrillasStyles.css'; //Con importar los estilos de grillas aqui, ya queda aplicado para GrillaDocumentos y GrillaProcsProgramados.
import controlContext from "../../context/control/controlContext";
import authContext from "../../context/authentication/authContex";
import activoContext from "../../context/activoContex/activoContex";
import informesContext from "../../context/informesContext/informesContext";
import { STATES } from "../../utils/states";
import normalizeText from "../../utils/normalizeText";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import usuariosContext from "../../context/usuarios/usuariosContext";
import SelectColumns from "./SelectColumns";
import Table from "./Table";

const GrillaActivos = ({setGridToShow}) => {
    
    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const acContext = useContext(activoContext);
    const {activoList, actualizaractivoList, getInfoActivosReporte, procsProgramadosList, docsXactivoList, getMantenimientosProgramados, getDocsXActivo} = acContext;

    const uContext = useContext(usuariosContext);
    const {userListView, saveColumnsPreferences} = uContext

    const iContext = useContext(informesContext);
    const {generarInformeExcel} = iContext;

    let columnsPreferences = useMemo(()=> usuario?.columnsPreferences?.columnasActivos ?? [], [usuario])

    const [columns, setColumns] = useState([
        {width: 150, property: 'fecAlt', title: 'Fecha de Alta', visible: true },
        {width: 250, property: 'codActivo', title: 'Codigo', visible: true },
        {width: 275, property: 'name', title: 'Nombre', visible: true },
        {width: 100, property: 'actStatus', title: 'Estado', visible: true },
        {width: 100, property: 'fecIng', title: 'Ingreso', visible: true },
        {width: 150, property: 'nivel1Name', title: 'Nivel1', visible: true },
        {width: 150, property: 'nivel2Name', title: 'Nivel2', visible: true },
        {width: 150, property: 'uniMedLastLectura', title: 'Unidad Medida Ult. Lectura', visible: true },
        {width: 150, property: 'lastLecturaNotCaringUnimed', title: 'Ultima Lectura', visible: true },
        {width: 150, property: 'nameNivel3', title: 'Nivel3', visible: true },
    ]);

    const activosWithAttributesModelated = useRef(undefined);
    const activosAlreadyLoaded = useRef(false);
    const [activoListFiltered,setActivoListFiltered] = useState((activoList != undefined) ? activoList : undefined);
    const [filter,setFilter] = useState('');
    const [showSelectColumns,setShowSelectColumns] = useState(false);
    const [loading,setLoading] = useState(true);


    const handleGenerarInforme = async() =>{
        let dataToExcel = []; //Arreglo que contendra tanto el Header del excel como las Filas Hijas de Informacion.
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title); //Arreglo que contiene el nombre de las columnas o header.
        dataToExcel.push(columnsTitle); //Se pushea la primer fila del excel.

        //Por cada OT filtrada se crea un array nuevo, a este se le pushearan las propiedades que hayan sido especificadas en la visualizacion del informe en el frontend.
        for(const o of activoListFiltered){
            let otModelado = [];
            for(const col of columns){
                if(!col.visible) continue;
                (Array.isArray(o[col.property])) ? otModelado.push(o[col.property].length) : (col.property == 'fecAlt') ? otModelado.push(o[col.property].toLocaleString().substring(0,16).replace("T", " ")) : (col.property == 'valorMaterialesString') ?  otModelado.push(o["valorMateriales"]) : (col.property == 'valorRRHHString') ?  otModelado.push(o["valorRRHH"]) : otModelado.push(o[col.property]);
            }
            if(otModelado.length > 0) dataToExcel.push(otModelado); //Si algun campo coincidio lo pushea a dataToExcel para ser impresa en el .xlsx.
        }
        await generarInformeExcel(dataToExcel, 'OrdenesTrabajo'); //Viaja hacia la funcion del contexto para ser generado el xlsx.
    }


    const handleChangeColumnsVisible = (e, c, i) =>{
        setColumns((prevCols) => prevCols.map((c,index) => index == i ? {...c, visible: e.target.checked} : c))
    }

    //resFiltered llega como referencia al array, por lo que al recorrerlo y modificar los objetos presentes dentro de el, estamos modificando directamente el arreglo original, evitando asi tener que retornar el arreglo modificado.
    const modelateTable = (resFiltered) => {
        let columnsWithAttributes = [...columns];
        let activosModelados = [];

        for(const act of resFiltered){
            let activoModelado = {...act};

            if(act.fichaTecnica && act.fichaTecnica.length > 0){
                
                for(const a of act.fichaTecnica){
                    activoModelado[a.codAtributo] = a.valor;

                    if(!columnsWithAttributes.some(c => c.property == a.codAtributo)) columnsWithAttributes.push({property: a.codAtributo, title: a.atributoID.name, fichaTecnica: true, visible: true, width:150});
                }        
            }
            activosModelados.push(activoModelado);
        } 
        activosWithAttributesModelated.current = activosModelados

        setActivoListFiltered(activosModelados);
        setColumns(columnsWithAttributes);
        setLoading(false)
    }

    useEffect(()=>{
        if(filter != ''){
            if(!loading){
                const nFilter = normalizeText(filter);
                let acts = activosWithAttributesModelated.current.filter(a => normalizeText(a.codActivo).includes(nFilter) || normalizeText(a.name).includes(nFilter))
                setActivoListFiltered(acts);
            }
        }else setActivoListFiltered((activosWithAttributesModelated.current != undefined) ? activosWithAttributesModelated.current : undefined);
    },[filter]);

    useEffect(()=>{
        getInfoActivosReporte()
        .then(res => {
            if(res.data && !activosAlreadyLoaded.current){
                activosAlreadyLoaded.current = true;  
                modelateTable(res.data);
            } 
        })
    },[])

    useEffect(()=>{
        if(columnsPreferences && columnsPreferences.length > 0 && !loading){
            setColumns(prevColumns => prevColumns.map(c => ({...c, visible: columnsPreferences.includes(c.property)})))
        }
    },[columnsPreferences, loading])

    return <div className="grillaInformeDiv">
        <div className="utilitiesDiv">
            <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
            <SearchInput filter={filter} buscar={setFilter}/>
            <button className="selectColumnsBtn" onClick={()=>setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells}/></button>
            <button disabled={loading || activoListFiltered == undefined || activoListFiltered.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload}/></button>
        </div>
        {
            (activoListFiltered == undefined || loading) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (activoListFiltered.length == 0) ? <h3 className="warningStatusMsg">No hay ordenes de trabajo cargadas</h3> : <Table array={activoListFiltered} columns={columns} setColumns={setColumns}/>
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"Activos"}/>
        }
    </div>
}

export default GrillaActivos;